/* Keyboard + ARIA support for category accordions (existing jQuery handler still toggles them). */
(function () {
  function sync(el) {
    var t = el.querySelector('[data-accordion-trigger]');
    if (t) t.setAttribute('aria-expanded', el.classList.contains('active') ? 'true' : 'false');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('[data-accordion-trigger]');
    if (!t) return;
    e.preventDefault();
    t.closest('.custom_product_accordion').click();
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-a11y-accordion]');
    if (a) setTimeout(function () { sync(a); }, 0);
  });
})();
